"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var react_1 = require("@emotion/react");
var intl_tel_input_1 = __importDefault(require("intl-tel-input"));
var react_2 = require("react");
var Input_1 = __importDefault(require("../../../Components/Atoms/Input"));
var InputLabel_1 = __importDefault(require("../../../Components/Atoms/InputLabel"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var makeFormControlPhoneNumberStyling_1 = __importDefault(require("./makeFormControlPhoneNumberStyling"));
var makeFormControlStyles_1 = __importDefault(require("../../../Components/Atoms/FormControl/makeFormControlStyles"));
var setUserAgent = function (userAgent) {
    Object.defineProperty(navigator, 'userAgent', {
        get: function () {
            return userAgent; // customized user agent
        },
        configurable: true,
    });
};
var getInput = function (id) {
    return document.querySelector("#".concat(id));
};
var initIntlTelInput = function (input) {
    // Keep the initial userAgent
    var initialUserAgent = navigator.userAgent;
    // Set mobile layout in userAgent
    setUserAgent('iPhone');
    // Init plugin
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    (0, intl_tel_input_1.default)(input, {
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js',
    });
    // Restore the initial userAgent
    setUserAgent(initialUserAgent);
};
var PhoneNumberTextField = function (_a) {
    var errorMessage = _a.errorMessage, id = _a.id, isAnswered = _a.isAnswered, onChange = _a.onChange, value = _a.value, label = _a.label, isSafari = _a.isSafari, isAutoFilledActive = _a.isAutoFilledActive, experimentName = _a.experimentName, props = __rest(_a, ["errorMessage", "id", "isAnswered", "onChange", "value", "label", "isSafari", "isAutoFilledActive", "experimentName"]);
    var theme = (0, react_1.useTheme)();
    (0, react_2.useEffect)(function () {
        var input = getInput(id);
        initIntlTelInput(input);
        input.addEventListener('countrychange', function (e) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onChange({ id: id, value: e.target.value });
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(FormControl_1.default, { variant: "standard", error: !!errorMessage, fullWidth: true, css: [
            (0, makeFormControlPhoneNumberStyling_1.default)({ isAnswered: isAnswered }),
            (0, makeFormControlStyles_1.default)({ isAutoFilledActive: isAutoFilledActive, isSafari: isSafari, theme: theme }),
        ], children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.default, { isAnswered: isAnswered, htmlFor: id, shrink: true, experimentName: experimentName, children: label })), (0, jsx_runtime_1.jsx)(Input_1.default, __assign({ error: !!errorMessage, id: id, onChange: onChange, isAnswered: isAnswered, value: value, isSafari: isSafari, isAutoFilledActive: isAutoFilledActive, experimentName: experimentName }, props)), errorMessage && (0, jsx_runtime_1.jsx)(FormHelperText_1.default, { children: errorMessage })] }));
};
PhoneNumberTextField.defaultProps = defaultProps_1.default;
exports.default = PhoneNumberTextField;
//# sourceMappingURL=PhoneNumberTextField.js.map